import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

export const ProcessFlow = () => {
  const { t } = useLanguage();
  const steps = t("processSteps");

  return (
    <div className="w-full max-w-[1200px] mx-auto py-10 md:py-16 px-4 md:px-0">
      <div className="space-y-10 md:space-y-16">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-8"
          >
            {/* Step Number Box */}
            <div className="flex-shrink-0">
              <div className="w-14 h-14 sm:w-20 sm:h-20 border border-[#5a6e54] bg-[#0f0f10] flex items-center justify-center opacity-70">
                <span
                  className="text-base sm:text-xl font-normal text-[#5a6e54]"
                  style={{ fontFamily: "var(--font-eurostile)" }}
                >
                  {step.number}
                </span>
              </div>
            </div>

            {/* Step Content */}
            <div className="min-w-0">
              <h3
                className="uppercase text-[#d8d8d8] font-bold mb-1 sm:mb-2 text-2xl sm:text-3xl leading-tight"
                style={{
                  fontFamily: "var(--font-eurostile)",
                  wordBreak: "normal",
                  overflowWrap: "normal",
                  hyphens: "none",
                }}
              >
                {step.title}
              </h3>

              {step.description && (
                <p
                  className="uppercase text-[#888] text-base sm:text-xl leading-snug"
                  style={{
                    fontFamily: "var(--font-eurostile)",
                    fontWeight: "400",
                    wordBreak: "normal",
                    overflowWrap: "normal",
                    hyphens: "none",
                  }}
                >
                  {step.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
